import PropTypes from 'prop-types';
var refType = PropTypes.oneOfType([PropTypes.func, PropTypes.object]);
export default refType;


//////////////////
// WEBPACK FOOTER
// ../~/@material-ui/core/~/@material-ui/utils/esm/refType.js
// module id = 1665
// module chunks = 121